<template>
  <div class="paired-product-sets">
    <h2
      v-if="!isEmptyMetafieldHandle && title"
      class="paired-product-sets__title text-heading-s text-heading-l-desktop"
      v-text="title"
    />
  
    <div
      v-if="!isEmptyMetafieldHandle"
      class="paired-product-sets__container container grid"
    >
      <product-card
        v-for="(content, index) of updatedProducts"
        :key="index"
        class="paired-product-sets__product-card col xs2 l6"
        :index="index"
        :product="content"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Paired product sets (paired-product-sets)
 * -----------------------------------------------------------------------------
 * Paired product sets for PDP.
 * @param {Object} productPairSets - Product pair sets object.
 * @param {String} title - Product title.
 *
 */
import ProductCard from '~async/product-card/product-card.vue'
import { formatProduct } from '~/helpers/format'
import product from '~/graphql/queries/product.gql'

export default {
  name: 'PairedProductSets',
  
  components: {
    ProductCard,
  },
  
  props: {
    product: {
      type: [Object, Boolean],
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      currentHandle: this.product.handle,
      updatedProducts: [false, false],
      metafieldHandle: null,
    }
  },
  
  computed: {

    /**
     * Returns current metafield handle.
     * @return {boolean}
     */
    isEmptyMetafieldHandle() {
      return this.metafieldHandle === 'empty'
    },
  },
  
  watch: {

    /**
     * Watch currentHandle for update to load new product.
     */
    'product.handle': function (newHandle, oldHandle) {
      if (newHandle !== oldHandle) {
        this.currentHandle = newHandle
        this.queryProducts()
      }
    },
  },

  mounted() {
    this.queryProducts()
  },

  methods: {


    /**
     * Query products from GraphQL API.
     */
    async queryProducts() {
      this.metafieldHandle = this.product.metafields.find(
        metafield => metafield.name.includes('shop_the_look'),
      )?.value

      if (!this.metafieldHandle || this.metafieldHandle === 'empty') {
        return
      }

      try {
        this.queue = this.metafieldHandle.map((item) => {
          const handle = item.handle

          return cnvs.Query({
            query: product,
            variables: {
              country: cnvs.store.country,
              handle,
              language: cnvs.store.language,
            },
          })
        })

        const response = await Promise.allSettled(this.queue)
        const products = response
          .map((promise) => {
            if (promise.status !== "fulfilled") {
              return false
            }

            return formatProduct(promise.value)
          })
          .filter(Boolean)

        /**
         * If no products returned then error.
         */
        if (!products.length) {
          this.state = "error"
          return
        }

        this.updatedProducts = products
        this.state = "ready"
      } catch (error) {
        this.state = "error"
        throw new Error(error)
      }
    },
  },
}
</script>

<style lang="scss">
@import './paired-product-sets';
</style>
